import type User from '../User';
import type CartaIdComponent from '../viewModels/CartaId/CartaIdComponent';

export default interface ApprovalContact {
	name: string;
	email?: string;
}

export function fromUser(user: User | null | undefined): ApprovalContact | null {
	return user
		? {
				name: user.displayName,
				email: user.email?.address || user.userPrincipalName?.address,
			}
		: null;
}

export function fromEmails(emails: string[] | null | undefined): string | undefined {
	return emails?.filter((email) => !!email).join(', ') || undefined;
}

export function fromAppEndorser(appEndorser: CartaIdComponent | null | undefined): ApprovalContact | null {
	return appEndorser?.id
		? {
				name: appEndorser.displayName,
				email: appEndorser.customFields?.contact_email,
			}
		: null;
}
